export type ServiceCategory =
  | 'all'
  | 'hair'
  | 'braiding'
  | 'barber'
  | 'nails'
  | 'makeup'
  | 'skincare'
  | 'massage'
  | 'lashes'
  | 'brows'
  | 'waxing'
  | 'wellness'
  | 'fitness'
  | 'therapy';

export const PROMOTION_SERVICE_CATEGORIES: ServiceCategory[] = [
  'all', 'hair', 'braiding', 'barber', 'nails', 'makeup',
  'skincare', 'massage', 'lashes', 'brows', 'waxing', 'wellness', 'fitness', 'therapy',
];

export const SERVICE_CATEGORY_LABELS: Record<ServiceCategory, string> = {
  all: 'All Services',
  hair: 'Hair',
  braiding: 'Braiding',
  barber: 'Barber',
  nails: 'Nails',
  makeup: 'Makeup',
  skincare: 'Skincare',
  massage: 'Massage',
  lashes: 'Lashes',
  brows: 'Brows',
  waxing: 'Waxing',
  wellness: 'Wellness',
  fitness: 'Fitness',
  therapy: 'Therapy',
};

export const SERVICE_CATEGORY_EMOJIS: Record<ServiceCategory, string> = {
  all: '✨',
  hair: '✂️',
  braiding: '🌸',
  barber: '💈',
  nails: '💅',
  makeup: '💄',
  skincare: '🧴',
  massage: '💆',
  lashes: '👁️',
  brows: '🤨',
  waxing: '🔥',
  wellness: '🌿',
  fitness: '💪',
  therapy: '🩺',
};
